'use client'

import {
  createContext,
  useContext,
  type ReactNode,
} from 'react'

import {
  usePromanityExperience,
  type PromanityExperience,
  type PromanityExperienceOptions,
} from '@/hooks/promanity/usePromanityExperience'

const PromanityExperienceContext =
  createContext<PromanityExperience | null>(null)

export interface PromanityExperienceProviderProps
  extends PromanityExperienceOptions {
  children: ReactNode
}

export function PromanityExperienceProvider({
  children,
  ...options
}: PromanityExperienceProviderProps) {

  const experience =
    usePromanityExperience(options)

  return (
    <PromanityExperienceContext.Provider
      value={experience}
    >
      {children}
    </PromanityExperienceContext.Provider>
  )
}

export function usePromanityExperienceContext() {
  const context =
    useContext(PromanityExperienceContext)

  if (!context) {
    throw new Error(
      'usePromanityExperienceContext must be used inside PromanityExperienceProvider'
    )
  }

  return context
}